import { IconButton } from "@mui/material";
import { ViewSidebarOutlined } from "@mui/icons-material";
import PropTypes from "prop-types";
import {
  getNavCollapseIconSx,
  navCollapseButtonSx,
} from "../TopHeader.style";

const NavCollapseButton = ({ isCollapsed, onToggle }) => (
  <IconButton
    onClick={onToggle}
    aria-label={isCollapsed ? "Expand navigation" : "Collapse navigation"}
    title={
      isCollapsed ? "Expand sidebar (⌘B)" : "Collapse sidebar (⌘B)"
    }
    sx={navCollapseButtonSx}
  >
    <ViewSidebarOutlined sx={getNavCollapseIconSx(isCollapsed)} />
  </IconButton>
);

NavCollapseButton.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default NavCollapseButton;
